import { render, staticRenderFns } from "./AddDayStart.vue?vue&type=template&id=0b15ad0d&"
import script from "./AddDayStart.vue?vue&type=script&lang=js&"
export * from "./AddDayStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports